import { render } from "./nationSelector.vue?vue&type=template&id=3e7912c8&scoped=true"
import script from "./nationSelector.vue?vue&type=script&lang=js"
export * from "./nationSelector.vue?vue&type=script&lang=js"

import "./nationSelector.vue?vue&type=style&index=0&id=3e7912c8&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7912c8"]])

export default __exports__